export const MAX_VIDEO_DURATION_SEC = 300; // 5 minutes
